import React, { useState } from "react";
import { Form, InputGroup, Button } from "react-bootstrap";

/**
 * PasswordInput — campo de contraseña con botón de mostrar/ocultar.
 *
 * Reemplaza a `<Form.Control type="password" .../>` en formularios de
 * login/registro/reset. Reenvía todas las props al `Form.Control` interno
 * (value, onChange, required, minLength, autoComplete, placeholder, id,
 * isInvalid, …). Si se pasa `errorText`, renderiza el feedback de validación
 * dentro del InputGroup (Bootstrap lo exige como hermano del control).
 *
 * El botón lleva `tabIndex={-1}` para no interrumpir el tabulado del formulario.
 */
function PasswordInput({ errorText, isInvalid, ...controlProps }) {
  const [show, setShow] = useState(false);

  return (
    <InputGroup hasValidation>
      <Form.Control
        {...controlProps}
        type={show ? "text" : "password"}
        isInvalid={isInvalid}
      />
      <Button
        variant="outline-secondary"
        type="button"
        tabIndex={-1}
        onClick={() => setShow((v) => !v)}
        aria-label={show ? "Ocultar contraseña" : "Mostrar contraseña"}
      >
        <i
          className={`mdi ${show ? "mdi-eye-off-outline" : "mdi-eye-outline"}`}
          aria-hidden="true"
        />
      </Button>
      {errorText && (
        <Form.Control.Feedback type="invalid">
          {errorText}
        </Form.Control.Feedback>
      )}
    </InputGroup>
  );
}

export { PasswordInput };
